import { SxProps, Theme } from '@mui/material'
import { isDealer } from '../../../services/AccountService'

export const getHeadTypographySx = (cellClasses: any) => ({
  ...cellClasses.headerText,
  textAlign: 'left',
})

export const getTableHeadSx = (classes: any) =>
  isDealer()
    ? {
        ...classes.tableRow,
        display: {
          xs: 'none',
          sm: 'table-header-group',
        },
      }
    : classes.tableRow

export const getWrapperSx = (smallPadding = false) => ({
  background: '#FFF',
  borderRadius: '8px',
  padding: smallPadding ? '0 0 24px 0' : '16px 0  24px',
})

export const getTypographySx = (bodyCellClasses: any) => ({
  ...bodyCellClasses.contentText,
  textAlign: 'left',
})

export const getCellBoxSx = (bodyCellClasses: any) => ({
  ...bodyCellClasses.cellContainer,
  justifyContent: 'start',
})

export const chipSx: SxProps<Theme> = {
  padding: '8px 4px',
  borderRadius: '6px',
  background: (
    theme // @ts-ignore
  ) => `${theme.palette.gray.veryLightGray}`,
  display: 'flex',
  gap: '4px',
}
